const { conf } = require('./configService');

const urlService = {
  isExternal: url => {
    if (urlService.isRelative(url)) {
      return false;
    }
    const { hostname } = new URL(url);
    return hostname !== conf.canonicalDomain;
  },

  isAbsolute: url => url.match(/^https?:\/\//i),

  isRelative: url => !urlService.isAbsolute(url)
};

module.exports = { urlService };
